import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Icon } from 'react-fa';
import './Footer.css';

class Footer extends Component {
	render() {
		return (
			<div className="footer-container">
				<div className="row row-centered">
					<button type="button" className="btn btn-warning footer-get-started">Get Started</button>
				</div>
				<div className="row">
					{this.renderFooterLinkSections()}
				</div>
				<div className="container socialmedia-container">
						<div className="row">
							<div className="col-sm-12">
								<div className="row">
									{this.renderSocialMedia()}
								</div>
							</div>
						</div>
				</div>
			</div>
		);
	}

	renderFooterLinkSections() {
		return FooterSections.map(({ links }, i) => {
			return (
				<div className="col-sm-6 col-md-6" key={`s_${i}`}>
					<div className="footer-links-column">
						{this.renderLinks(links)}
					</div>
				</div>
			);
		});
	}

	renderLinks(links) {
		return links.map(({ title, link }, i) => { 
			return (
				<a href={link} key={`l_${i}`}>{title}</a>
			);
		});
	}

	renderSocialMedia() {
		return SocialMediaLinks.map(({ network, icon, link }, i) => {
			return (
					<div className="col-sm-4 socialmedia-icon-container">
						<span key={`social_${i}'`} className="socialmedia-circle">
			          		<Icon className="socialmedia-icon" name={icon} />
			          	</span>
		          	</div>
			);
		});
	}
}

const SocialMediaLinks = [
	{
		network: 'facebook',
		icon: 'facebook',
		link: 'www.google.com'
	},
	{
		network: 'twitter',
		icon: 'twitter',
		link: 'www.google.com'
	},
	{
		network: 'linkedin',
		icon: 'linkedin',
		link: 'www.google.com'
	}
];

const FooterSections = [
	{ title: 'About us',
		links: [
			{
				title: 'jobs',
				link: 'www.google.com'
			},
			{
				title: 'About Us',
				link: 'www.google.com'
			},
			{
				title: 'Contact Us',
				link: 'www.google.com'
			},
			{
				title: 'Contact Us',
				link: 'www.google.com'
			}
		]
	},
	{ title: 'Help',
		links: [
			{
				title: 'Help',
				link: 'www.google.com'
			},
			{
				title: 'Security',
				link: 'www.google.com'
			},
			{
				title: 'FAQ',
				link: 'www.google.com'
			},
			{
				title: 'Site Map',
				link: 'www.google.com'
			}
		]
	}
];


export { Footer };



/** WEBPACK FOOTER **
 ** ./src/common/Footer.js
 **/